import { ABTest, ABTestOptions, ABTestEnv } from "@meitu/ab-test";

interface IInitABTest {
  (): Promise<void>;
}
interface AbInfo {
  ab_codes: Array<{
    code: number;
    count: number;
  }>;
  version: string;
}

let abInfo = {} as AbInfo;

interface ABTestInstance {
  init(): void;
  getABInfo(): AbInfo;
  isInABTesting(code: number): boolean;
}

let abTest: ABTestInstance | null = null;

export const initABTest: IInitABTest = async () => {
  const abTestParams: ABTestOptions = {
    /** Web项目id */
    appKey: "C5F34252F04B6D50",
    /** 环境变量 不传默认选择正式环境*/
    env: ABTestEnv.Release,
  };

  // 实例化 ABTest SDK
  const abTestInstance = new ABTest(abTestParams) as ABTestInstance;

  await abTestInstance.init(); // 初始化 ABTest SDK
  abTest = abTestInstance;

  abInfo = abTest.getABInfo();

  // 通过websdk 设置ab_info的信息
  window.mtstat?.setABInfo(abInfo);
};

export const getAbInfo = () => {
  return abInfo;
};
/**
 * 是否开启deepsSeek
 */
export const isOpenDeepSeek = async () => {
  if (!abTest) await initABTest();
  // 对照组，默认开启
  if (abTest?.isInABTesting(25314)) {
    console.log("【isOpenDeepSeek】对照组，默认开启");
    return true;
  }
  // 实验组，默认关闭
  if (abTest?.isInABTesting(25315)) {
    console.log("【isOpenDeepSeek】实验组，默认关闭");
    return false;
  }
  console.log("【isOpenDeepSeek】默认开启");
  return true;
};

/**
 * ppt商业化
 */
export const isOpenPptCommercialization = async () => {
  if (!abTest) await initABTest();
  // 对照组，默认关闭
  if (abTest?.isInABTesting(27220)) {
    return {
      isHitGroupOne: false,
      isHitGroupTwo: false,
    };
  }
  // 实验组1
  if (abTest?.isInABTesting(27221)) {
    return {
      isHitGroupOne: true,
      isHitGroupTwo: false,
    };
  }
  // 实验组2
  if (abTest?.isInABTesting(27222)) {
    return {
      isHitGroupOne: false,
      isHitGroupTwo: true,
    };
  }
  return {
    isHitGroupOne: false,
    isHitGroupTwo: false,
  };
};
